const DEFAULT_COOKIE_NAME = 'elli_guest_advisory_seen';
const COOKIE_MAX_AGE = 60 * 60 * 24 * 365;

function hasDismissedAdvisory(cookieName) {
    return document.cookie
        .split(';')
        .some((cookie) => cookie.trim().startsWith(`${cookieName}=`));
}

function rememberDismissal(cookieName) {
    document.cookie = `${cookieName}=1; Max-Age=${COOKIE_MAX_AGE}; Path=/; SameSite=Lax`;
}

export function initGuestAdvisory() {
    const modal = document.querySelector('.js-guest-advisory');
    if (!modal) return;

    const cookieName = modal.dataset.cookieName || DEFAULT_COOKIE_NAME;
    if (hasDismissedAdvisory(cookieName)) return;

    const closeButton = modal.querySelector('.js-guest-advisory-close');
    if (!closeButton) return;

    modal.hidden = false;
    window.requestAnimationFrame(() => {
        modal.classList.add('is-visible');
    });

    const dismiss = () => {
        rememberDismissal(cookieName);
        modal.classList.remove('is-visible');
        document.removeEventListener('keydown', handleKeydown);

        window.setTimeout(() => {
            modal.hidden = true;
        }, 300);
    };

    closeButton.addEventListener('click', dismiss);

    function handleKeydown(event) {
        if (event.key === 'Escape') {
            event.preventDefault();
            dismiss();
        }

    }

    document.addEventListener('keydown', handleKeydown);
}
